import { Modal } from 'antd';
import React from 'react';

import BaseModal from '@/components/CartPage/AddressesModal/BaseModal';
import { montserrat } from '@/components/Layout';

import { Address } from '@/utils/interfaces/Manage-Addresses';

interface Props {
  open: boolean;
  isSelectButton?: boolean;
  onCancel?:
    | ((e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  onOk?:
    | ((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void)
    | undefined;
  addresses: Address[] | undefined;
  onSelect?: (e: Address) => void;
  selectedAddress?: Address | null;
  onClickCreate?: () => void;
  onClickEdit?: (address: Address) => void;
  isBillingButton?: boolean;
  /** When true, renders a "Set as Default" button on each address row */
  showDefaultButton?: boolean;
  /** Called when user clicks "Set as Default"; should return a Promise */
  onSetDefault?: (address: Address) => Promise<void>;
}

const AddressesModal: React.FC<Props> = ({
  isSelectButton,
  open,
  onCancel,
  onOk,
  addresses,
  onSelect,
  selectedAddress,
  onClickCreate,
  onClickEdit,
  isBillingButton,
  showDefaultButton = false,
  onSetDefault,
}) => {
  return (
    <Modal
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      footer={false}
      centered
      closeIcon={false}
      classNames={{
        content: 'bg-cardBg p-0 rounded-[12px]',
      }}
      style={{
        fontFamily: montserrat.style.fontFamily,
      }}
    >
      <BaseModal
        isBillingButton={isBillingButton}
        isSelectButton={isSelectButton}
        varient='modal'
        onCancel={onCancel}
        addresses={addresses}
        onSelect={onSelect}
        selectedAddress={selectedAddress}
        onClickCreate={onClickCreate}
        onClickEdit={onClickEdit}
        showDefaultButton={showDefaultButton}
        onSetDefault={onSetDefault}
      />
    </Modal>
  );
};

export default AddressesModal;
